import React from 'react';
import FormCard from '../../../../../../components/FormCard';
import FormRow from '../../../../../../components/FormRow';
import Field from '../../../../../../components/Field';
import Dropdown from '../../../../../../components/Dropdown';
import styles from '../../../../css/inventoryItemDetail.module.css';

export default function FSSupplierCard({ f, errors = {}, suppliers = [], onSupplierChange }) {
  return (
    <FormCard>
      <FormRow className={styles.row}>
        <Field label="Shelve Number" error={errors?.shelvenumber}>
          <input
            className={`${styles.tallInput} ${styles.fsTextInputUnified}`}
            type="text"
            value={f.shelve}
            onChange={e => f.setShelve(e.target.value)}
            placeholder="A1"
          />
        </Field>
        <Field label="Supplier" error={errors?.supplier}>
          <Dropdown
            options={(Array.isArray(suppliers) ? suppliers.map(s => s?.suppliername).filter(Boolean) : [])}
            value={f.supplier}
            onChange={onSupplierChange}
            className={styles.tallInput}
            placeholder="Select"
            alignLeft
          />
        </Field>
        <Field label="Supplier Code" error={errors?.suppliercode}>
          <input
            className={`${styles.tallInput} ${styles.fsTextInputUnified}`}
            type="text"
            value={f.supplierCode}
            readOnly
          />
        </Field>
      </FormRow>
    </FormCard>
  );
}
